import { computed, Injectable, signal } from '@angular/core';
import { BrowserInfo } from './interfaces/browser-info.interface';

@Injectable({
  providedIn: 'root'
})
export class CookiesDetectionService {

  cookiesBlocked = signal<boolean>(false);
  browserInfo = signal<BrowserInfo>({
    isIOS: false,
    isChrome: false,
    isSafari: false,
    isFirefox: false,
    isEdge: false
  });

  //Esto es para utilizarlo para dar instrucciones por navegador para activar cookies
  errorMessage = computed(() => {
    if(!this.cookiesBlocked()) return '';
    
    const info = this.browserInfo();
    if(info.isIOS) return 'Instrucciones para IOS';
    if(info.isChrome) return 'Instrucciones para Chrome';
    return 'Instrucciones generales';
  })

  areCookiesEnabled(): boolean {
    try{
      document.cookie = 'cookieTest=1; SameSite=Lax; path=/; Secure';
      const cookiesEnabled = document.cookie.indexOf('cookieTest=') !== -1;
      document.cookie = 'cookieTest=; max-age=0; path=/';

      this.cookiesBlocked.set(!cookiesEnabled);

      if(!cookiesEnabled) {
        this.browserInfo.set(this.getBrowserInfo());
      }

      return cookiesEnabled;
    } catch (e) {
      this.cookiesBlocked.set(true);
      return false;
    }
  }

  getBrowserInfo(): BrowserInfo {

    const ua = navigator.userAgent;
    return {
      isIOS: /iPad|iPhone|iPod/.test(ua),
      isChrome: /Chrome/.test(ua) && !/Edge|Edg/.test(ua),
      isSafari: /Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua),
      isFirefox: /Firefox/.test(ua),
      isEdge: /Edg/.test(ua)
    };
  }
  
}
